import { ilcConfigRoot } from './IlcConfigRoot';

export const getIlcConfigRoot = () => ilcConfigRoot;
